import React, { useRef, useCallback, useState, useEffect } from "react";
import LightGallery from 'lightgallery/react';
import lgZoom from 'lightgallery/plugins/zoom';
import lgVideo from 'lightgallery/plugins/video';
import lgRotate from 'lightgallery/plugins/rotate';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-fullscreen.css';
import 'lightgallery/css/lg-rotate.css';
import { Link,useParams } from 'react-router-dom';
import axios from 'axios';
import "../inc/GlobalVars";
import { ToastContainer, toast } from 'react-toastify';
import parse from 'html-react-parser';
import   submitBid   from "../inc/hooks/submitBid";

const VehicleGallery = () => {
  const { id } = useParams();
  const [images, setImages] = useState([]);
  const user_id = localStorage.getItem('userId'); 
  const [vehicleData,setVehicleData] = useState([]);
  const [vehicleImages,setVehicleImages] = useState([]);
  const [auctionListItems, setAuctionListItems] = useState([]);
  const [watchListStatus,setWatchListStatus] = useState("not_added");
  const lightGallery = useRef(null);
  useEffect(() => {

    
    getVehicleDetails();
    getAuctionList();
    fetchImages();
 
    
   
  }, []);

  const fetchImages = async () => {
    try {
      const response = await axios.post(global.apiUrl + "/getVehicleDetailsGallery/" + id);
      setImages(response.data.data);
      
    } catch (error) {
      console.error("Error fetching images:", error);
      
    }
  };

  const onInit = useCallback((detail) => {
    if (detail) {
      lightGallery.current = detail.instance;
    }
  }, []);

  const userAndVehicleId = {user_id:user_id,vehicle_id:id}
  function getVehicleDetails()
  {
    axios.post(global.apiUrl + "/getVehicleDetails/",JSON.stringify(userAndVehicleId)).then(function (response) {
      const vdata = response.data["data"];
      
      setVehicleData(vdata[0]);
      setWatchListStatus(vehicleData['watchlist_data'] === "yes" ? "added" : "not_added")
     // console.log(vdata);
    });

  }
  
function getAuctionList() {
  axios.get(global.apiUrl + "/getSimilarVehicles/"+id+"/"+user_id).then(function (response) {
    const auctionData = response.data["data"];
    setAuctionListItems(auctionData);
  });
}

const addToWatchlist = (vehicleId) => {
  //watchlistId.current.value = vehicleId;
  const watchlist = {user_id:user_id,vehicle_id:vehicleId}
  
  axios.post(global.apiUrl+'/addToWatchList',JSON.stringify(watchlist)).then(function(response)
  {
      let status= response.data['status'];
      if(status == 400)
      {
          alert("Something Went Wrong");
      }
      else
      {
        setWatchListStatus("added");
        toast.success('Added To Watchlist!', {
          position: "top-left",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          });
      }

  }

  )
};

const removeFromWatchlist = (vehicleId) => {
  //watchlistId.current.value = vehicleId;
  const watchlist = {user_id:user_id,vehicle_id:vehicleId}
  
  axios.post(global.apiUrl+'/removeFromWatchList',JSON.stringify(watchlist)).then(function(response)
  {
      let status= response.data['status'];
      if(status == 400)
      {
          alert("Something Went Wrong");
      }
      else
      {
        setWatchListStatus("not_added");
        toast.success('Vehicle Removed From Watchlist', {
          position: "top-left",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          });
      }

  }

  )
};

const bidId = useRef(null);
    const bidNow = (vehicleId) => {
      bidId.current.value = vehicleId;
    };
    
    const data = { bid_amount:""}
    const [inputData, setInputData] = useState(data);
    
    const handleData = (e) =>
    {
        setInputData({...inputData,[e.target.name]:e.target.value});
    }
    const handleBidding = async(e) => {
    
      e.preventDefault();
      
      const bid_amount = inputData.bid_amount;
      const vehicleId = bidId.current.value; // Get vehicle ID from form
      await submitBid(bid_amount, vehicleId);
      
    }

  const launchGallery = () => {
    lightGallery.current.openGallery(0);
  };


  return (
    <div>
     <ToastContainer
position="top-left"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="colored"
/>
    <div className='container'>
          <div className='row'>
          <div className="col-md-12 mb-5  pt-5">
          <h1>Vehicle Details </h1>
          </div>
          </div>
      </div>
      <div className='container auction-list-sidebar mb-5'>
      <div className='row d-flex justify-content-center align-items-top'>
          <div className='col-md-3 position-relative'>
          <span className={vehicleData['bid_win_status'] == "no" ? "text-white bid-status-loosing" : "text-white bid-status-win"} style={{fontWeight:"bold"}}>{vehicleData['bid_win_status'] == "no" ? "Loosing" : "Winning"}</span>

          <Link onClick={(e)=>{e.preventDefault();launchGallery();}} className='text-decoration-none'>
            <img src={global.apiUrl +"/"+vehicleData['featured_image']} className='img-fluid carCarImage' />
            </Link>
              {
              watchListStatus === "added" || vehicleData['watchlist_data'] === "yes" ? 
              (
                <button className="btn btn-watchlist" onClick={() => removeFromWatchlist(vehicleData['vehicle_id'])}>Remove From WatchList</button>
              )
              :
              (
                <button className="btn btn-watchlist" onClick={() => addToWatchlist(vehicleData['vehicle_id'])}>Add To WatchList</button>

              )

            }
            
          </div>
      <button
        type="button"
        className="header__button"
        onClick={launchGallery}
      >
        Launch Gallery
      </button>
      </div></div>
      <LightGallery
        onInit={onInit}
        elementClassNames={'gallery'}
        dynamic={true}
        plugins={[lgZoom, lgVideo, lgRotate]}
        dynamicEl={images.map(image => ({
          src: image.src
         
        }))}
      />
    </div>
  );
};

export default VehicleGallery;
